import FrameBorder from '@/component/FrameBorder';
import { formatDataNumberToen } from '@/utils/helper';
import imgFrameBorder from '@assets/web-v3-images/FrameBorder.png';
import { useTranslation } from 'react-i18next';
import ProgressBar from './ProgressBar';

export default function RedeemMilestone({ data }) {
	const { t } = useTranslation()
	const target = data?.progress?.target || 0;
	const value = data?.progress?.current || 0;
	const expiring_balance = data?.expiring_balance || 0;
	const expires_in_days = data?.expires_in_days || 0;
	const available_withdraw_milestone = data?.available_withdraw_milestone || 0;
	const milestones = data?.withdraw_milestones || [];

	return (
		<FrameBorder>
			<div
				style={{
					backgroundImage: `url(${imgFrameBorder})`,
					backgroundSize: '100% 100%',
					backgroundRepeat: 'no-repeat',
				}}
			>
				{/* Phần trên: Milestone */}
				<div className="px-5 pt-4 pb-5">
					<div className="bg-[rgba(253,203,146,1)] shadow-[inset_0px_3px_0px_0px_rgba(242,172,126,1),0px_-1px_4px_0px_rgba(255,255,255,1),0px_1px_2px_0px_rgba(0,0,0,0.15)] rounded-4xl p-5">
						<p className="text-[rgba(161,92,7,1)] font-semibold text-[26px] mb-2">
							{value >= target ? t("loyalty_point.highest_redeem_milestone") : t("loyalty_point.next_redeem_milestone")}
						</p>
						<ProgressBar value={value} target={target} milestones={milestones} />
					</div>
				</div>

				{/* Phần dưới: 2 cột */}
				<div className="flex">
					{/* Cột trái */}
					<div className="flex-1 px-5 pt-0 py-4">
						<p className="text-[rgba(161,92,7,1)] text-[29px] font-semibold mb-1">
							{t("loyalty_point.redeem_available")}
						</p>
						<p className="text-[rgba(113,59,18,1)] font-bold text-[35px]">
							{formatDataNumberToen(available_withdraw_milestone)} LP
						</p>
					</div>

					{/* Divider dọc */}
					<div className="w-px bg-[rgba(247,178,122,1)] my-4" />

					{/* Cột phải */}
					{expiring_balance !== 0 &&
						<div className="flex-1 px-5 pt-0 py-4">
							<p className="text-[rgba(161,92,7,1)] text-[29px] font-semibold mb-1 flex items-center gap-1">
								⚠ {formatDataNumberToen(expiring_balance)}
								{expires_in_days === 0 ? t("loyalty_point.LP_expire") : t("loyalty_point.LP_expire_in")}
							</p>
							<p className="text-[rgba(113,59,18,1)] font-bold text-[35px]">
								{expires_in_days === 0
									? t('loyalty_point.to_day')
									: expires_in_days === 1
										? t('loyalty_point.tomorrow')
										: expires_in_days + " " + t("loyalty_point.days")}</p>
						</div>
					}
				</div>
			</div>
		</FrameBorder>
	)
}
